module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page_title gradient_overlay",
    staticStyle: {
      "background": "url(/assets/images/page_title_bg.jpg)"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h1', {
    directives: [{
      name: "lang",
      rawName: "v-lang.restaurants",
      modifiers: {
        "restaurants": true
      }
    }]
  }), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    directives: [{
      name: "lang",
      rawName: "v-lang.inicio",
      modifiers: {
        "inicio": true
      }
    }],
    attrs: {
      "to": "/"
    }
  })], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "lang",
      rawName: "v-lang.restaurants",
      modifiers: {
        "restaurants": true
      }
    }]
  })])])])]), _vm._v(" "), _c('main', {
    attrs: {
      "id": "room_page"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.imagen_destacada,
      "alt": ""
    }
  }), _vm._v(" "), (_vm.restaurant != null) ? _c('div', {
    staticClass: "main_title mt50"
  }, [_c('h2', [_vm._v(_vm._s(_vm.restaurant.name[_vm.currentLanguage]))])]) : _vm._e(), _vm._v(" "), (_vm.restaurant != null) ? _c('div', [_vm._v("\n                        " + _vm._s(_vm.restaurant.description[_vm.currentLanguage]) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('aside', {
    staticClass: "widget"
  }, [_c('help')], 1), _vm._v(" "), _c('aside', {
    staticClass: "widget"
  }, [_c('last-posts')], 1)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cfe0ae4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/restaurants/Single.vue
// module id = 383
// module chunks = 0